/**
 * React Query key factory for the admin panel.
 *
 * Hierarchical keys enable targeted invalidation:
 *   invalidateQueries({ queryKey: queryKeys.staff.all })   → wipes staff list
 *   invalidateQueries({ queryKey: queryKeys.homeLayout.all }) → wipes everything HLM
 *
 * @module hooks/queries/queryKeys
 */

export const queryKeys = {
  customers: {
    all: ['customers'] as const,
    list: (params?: Record<string, string>) => ['customers', 'list', params ?? {}] as const,
    detail: (id: string) => ['customers', 'detail', id] as const,
    locations: () => ['customers', 'locations'] as const,
  },
  staff: {
    all: ['staff'] as const,
    list: () => ['staff', 'list'] as const,
  },
  stores: {
    all: ['stores'] as const,
    list: () => ['stores', 'list'] as const,
  },
  brands: {
    all: ['brands'] as const,
    list: () => ['brands', 'list'] as const,
  },
  homeLayout: {
    all: ['home-layout'] as const,
    draft: () => ['home-layout', 'draft'] as const,
    live: () => ['home-layout', 'live'] as const,
    changes: () => ['home-layout', 'changes'] as const,
    suggestions: () => ['home-layout', 'suggestions'] as const,
    presence: () => ['home-layout', 'presence'] as const,
    publishHistory: (page?: number) => ['home-layout', 'publish-history', { page: page ?? 1 }] as const,
    productCounts: (storeId: string) => ['home-layout', 'product-counts', storeId] as const,
  },
  products: {
    all: ['products'] as const,
    list: (params: Record<string, string>) => ['products', 'list', params] as const,
    preview: (category: string, storeId: string | null) => ['products', 'preview', category, storeId] as const,
  },
} as const;
